import { initialZ3KSettingsState } from 'z3k-settings/redux/reducer';
export function getZ3KDialogStateForDevice(state) {
    return state.z3k_settings ?? initialZ3KSettingsState;
}
